import { Button } from "primereact/button";
import React from "react";
import { useTranslation } from "react-i18next";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

interface FilterActionButtonsProps {
  handleFilter: () => void;
  handleClear: () => void;
}

const FilterActionButtons: React.FC<FilterActionButtonsProps> = ({
  handleFilter,
  handleClear,
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <div className="filter-buttons">
      <Button
        type="submit"
        className="primary-btn"
        onClick={handleFilter}
        icon={<FilterAltOutlinedIcon fontSize="small" />}
      >
        {t("filter")}
      </Button>
      <Button
        type="submit"
        className="light-primary-btn"
        onClick={handleClear}
        icon={<ClearOutlinedIcon fontSize="small" />}
      >
        {t("clear")}
      </Button>
    </div>
  );
};

export default FilterActionButtons;
